import React from "react";

import edu from "../assets/images/icons/color-02.svg";
import Moment from "react-moment";
import { BadgeCheckIcon } from '@heroicons/react/solid';
import certCheck from "../assets/images/verifi.svg";
function Certificate({ data }) {
  return (
    <>
      <div className="px-2 px-md-4 rounded shadow py-2 py-md-3 bg-white mb-3">
        <div>
          <div className="backgroundHead flex items-center mb-3">
          <BadgeCheckIcon className=" w-6 text-gray-700"/>
            <span className="block ml-2 manpro font-medium uppercase text-gray-500">
              Certificate
            </span>
          </div>
          {data.map((data, idx) => {
            return (
              <div key={idx} className="stats-container">
                <div></div>
                <div className="summaryInfo ml-2 md:ml-5">
                  <div className="flex relative pb-6">
                    <div className="circle relative"></div>
                    <div className="timeline-show"></div>
                    <div className="flex-1 ml-2">
                      <div className="flex items-center">
                        <small className="block manpro font-regular text-gray-400 mr-2">
                          <Moment format={"YYYY"}>{data.start_date}</Moment> -{" "}
                          <Moment format={"YYYY"}>{data.end_date}</Moment>
                        </small>
                      </div>
                      <div className="flex items-center">
                        {data.isVerified === 1 ? <img src={certCheck}  alt="check" className=" w-12 h-12 relative -left-3"/> : ''}
                        <span className={`block manpro text-sm :md:text-base font-semibold ${data.isVerified === 1 && 'relative -left-4'}`} style={{ color: "var(--color-5)" }}>
                          {data.title}
                        </span>
                      </div>
                      <span className="block manpro font-medium text-sm :md:text-base">
                        {data.work_company}
                      </span>
                    </div>
                    <div className="w-14 h-14 md:w-20 md:h-20 inline-block border rounded-xl overflow-hidden">
                      {data.isVerified === 1 ? (
                        <div>
                          <a href={data.certificate_url} target="_blank">
                            <BadgeCheckIcon className="w-full p-3 text-gray-700"/>
                          </a>
                        </div>
                      ) : data.certificate_url ? (
                        <img src={data.certificate_url} alt="edu" className="w-full p-2" />
                      ) : (
                        <BadgeCheckIcon className="w-full p-3 text-gray-700"/>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default Certificate;
